import {StrategyDownloader} from '../../../../shared/campaign/StrategyDownloader';
import {markdownToPdf} from '../../../../shared/campaign/MarkdownPreview/utils';

export default function StrategyDownloaderIntegration({
  markdown = '',
  fileName = 'estrategia-campanha',
}) {
  if (!markdown?.trim()) {
    return null;
  }

  const handleDownload = () => {
    markdownToPdf(markdown, fileName);
  };

  return (
    <StrategyDownloader
      fileName={`${fileName}.pdf`}
      onClickDownload={handleDownload}
    />
  );
}
